import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../../app/api/routes';

export default ComposedComponent =>
  reduxFetch([
    {
      resource: 'legalDocuments',
      method: 'get',
      request: tag => ({ url: apiRoutes.communityLegalDocuments(tag) }),
    },
  ])(ComposedComponent);
